import React from 'react';
import { Text, View } from 'react-native';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import OperatorPanelButton from '@components/operatorPanel/components/elements/buttons/OperatorPanelButton';
import ProductionInformation from '@components/productionInformation';
import ColorWrapper from '@styles/colors';

import { getLinkingModalConfig, isWeb, Popup } from '@helpers';
import { fullWidth, scaleOP, width } from '@components/frame';
import { fontOP } from '@styles/fonts';

import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ColorFunction } from '@styles/colors/types';
import { Machine } from '@interfaces/machines';
import { IMAGE_HANDLING_HEADER_HEIGHT } from '@components/imageHandling/common';
import { BOTTOM_SHEET_TOP_OFFSET, TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface JobsEmptyScreenProps {
  scale?: ScaleFunction;
  font?: typeof fontOP;
  C: ColorFunction;
  selectedItem?: Machine;
}

const JobsEmptyScreen: React.FC<JobsEmptyScreenProps> = ({ C, scale = scaleOP, font = fontOP, selectedItem }) => {
  const onLinkToJobPress = () => {
    const cachedValues = {
      // to use the same values while linking process
      selectedItem: { ...selectedItem },
      productionBatchId: selectedItem?.machineStatus?.productionBatchId,
      selectedNCFileId: selectedItem?.machineStatus?.ncFileId,
      partId: selectedItem?.machineStatus?.partDetails?.partId,
    };

    Popup({
      Component: (p: any) => (
        <ProductionInformation
          {...{
            ...p,
            ...cachedValues,
            scale,
            font,
            isOperatorPanel: true,
            title: 'Link Batch to Job',
          }}
        />
      ),
      ...getLinkingModalConfig(scale),
      offsetTop: isWeb ? scale(18) : scale(BOTTOM_SHEET_TOP_OFFSET / 2),
      offsetBottom: scale(18),
      width: (isWeb ? fullWidth : width) - scale((isWeb ? fullWidth : width) > 1116 ? 36 : 0),
    });
  };

  return (
    <View
      testID={TEST_IDS.operatorPanel.information.jobs.emptyScreen}
      style={{
        flexDirection: 'row',
        alignSelf: 'center',
        justifyContent: 'center',
        flex: 1,
        transform: [{ translateY: -scale(IMAGE_HANDLING_HEADER_HEIGHT) }],
      }}
    >
      <View
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          gap: scale(10),
        }}
      >
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary'), textAlign: 'center' }]}>{i18n.t('No Job linked yet.')}</Text>
        <OperatorPanelButton
          {...{
            onPress: onLinkToJobPress,
            CC: (c: string) => C(c, false),
            text: 'Link To Job',
            iconConfig: {
              icon: 'linkPlus',
              height: scale(21),
              width: scale(20),
            },
            textFont: 'Headline Large Bold',
            textColor: 'Label/Light/AlwaysDark Primary',
            customButtonBgColor: 'Label/Light/AlwaysLight Primary',
            buttonContainerStyle: {
              width: scale(336),
              height: scale(120),
              paddingTop: scale(29.5),
              paddingBottom: scale(32.5),
              paddingHorizontal: scale(15),
              gap: scale(12),
              borderRadius: scale(18),
            },
            iconContainerStyle: {
              marginTop: scale(2),
              marginBottom: scale(2),
            },
            scale,
            font,
          }}
        />
      </View>
    </View>
  );
};

export default connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(ColorWrapper(JobsEmptyScreen));
